import '@mantine/core/styles.css';
import "./src/styles/global.css";

export const onClientEntry = () => {
    if (typeof window !== 'undefined') {
        const originalFetch = window.fetch;
        window.fetch = (input, init = {}) => {
            if (typeof input === 'string' && input.includes('/page-data/')) {
                init.cache = 'no-store';
            }
            return originalFetch(input, init);
        };
    }
};